import React, { ReactElement } from "react";
import { ToelichtingAdviesAlgemeenHoofdstuk } from "../../../../../.generated/rapportage/rapportagetypes";
import { Paragraph } from "../../../components/Paragraph";
import { Motivering } from "../../../components/Motivering";
import { Chapter } from "../../../components/Chapter";

export const ToelichtingAdviesAlgemeenChapter = ({
  hoofdstuk,
}: {
  hoofdstuk: ToelichtingAdviesAlgemeenHoofdstuk;
}): ReactElement => {
  const wens = hoofdstuk.wens
    ? [...hoofdstuk.wens]
    : /* istanbul ignore next */ [];
  if (hoofdstuk.financiering) {
    wens.unshift(hoofdstuk.financiering);
  }

  return (
    <Chapter data-testid="toelichting-advies-algemeen-chapter">
      <Paragraph paragraaf={hoofdstuk?.paragrafen?.["p3060101"]} />

      <Motivering
        wens={wens}
        advies={hoofdstuk?.advies}
        keuze={hoofdstuk?.keuze}
      />
    </Chapter>
  );
};
